<template>
    <div>
        <div class="member-list">
            <div class="member-item" v-for="(item,index) in StudentList">
                <img src="@/assets/images/default-avatar.jpg" alt="">
                <div class="truename">{{item.truename}}</div>
            </div>
        </div>

        <noData v-if="total == 0"></noData>

        <div class="pagination-box" style="margin-left: 20px;margin-top: 20px;">
            <el-pagination class="ou-pagination" background hide-on-single-page @size-change="changePageSize"
                @current-change="changePageCurrent" :current-page="pageNum" :page-sizes="[5, 10, 15, 20]"
                :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper, slot" :total="total">
                <el-button @click="getCurrentTabList" class="ou-page-go">GO</el-button>
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { GetStudentList } from '@/api/user/course'
import noData from "@/components/noData.vue";
export default{
    name:'ClassMembers',
    components: { noData },
    props:{
        courseData:{
            type:Object,
            default:{}
        }
    },
    data(){
        return{
            StudentList:[],
            pageNum: 1,
            pageSize: 66,
            total: 0,
        }
    },
    watch:{
      
    },
    mounted(){
        this.getlist()
    },
    methods:{
        getlist(){
            GetStudentList({
                classId:this.courseData.classId,
                pageNum:this.pageNum,
                pageSize:this.pageSize,
            }).then(res=>{
                this.total = res.total
                this.StudentList = res.rows
            })
        },
        //切换页尺寸
        changePageSize(val) {
            this.pageSize = val;
            this.getCurrentTabList()
        },
        changePageCurrent(val) {
            this.pageNum = val;
            this.getCurrentTabList()
        }, 
        getCurrentTabList(){
            this.getlist()
        },
    }
}
</script>
<style scoped lang='scss'>
.pagination-box{
    text-align: center;
    margin: 20px 0;
}
    .member-list{
        padding: 0 30px;
        display: grid;
        align-items: flex-start;
        grid-row-gap: 34px;
        grid-column-gap: 30px;
        justify-content: start;
        grid-template-columns: repeat(auto-fit, 65px);

        
        .member-item{
            text-align: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #666666;

            img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
            }

            .truename{
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                word-break: break-all;
            }
        }
    }
</style>